import { useEffect } from 'react'
import Sidebar from '../../components/Sidebar/Sidebar'
import './DashboardLayout.css'
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import SmallLogo from '../../assets/images/small-logo.svg';
import setting from '../../assets/images/setting.svg';
import logoutIcon from '../../assets/images/logout.svg';
import avatar from '../../assets/images/avatar.png';
import applications from '../../assets/images/applications.svg';
import { logout } from '../../service/authService'
const DashboardLayout = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

    return (
        <div className="dashboard-layout">
            <header style={{padding: '32px 48px 0 48px'}}>
                <img src={SmallLogo} alt="SmallLogo" />
                <div className='d-flex gap-24 align-items-center'> 
                    <img src={applications} alt="applications" className='applications' />
                    <img src={avatar} alt="avatar" className='logoimg' />
                    <span className='userName'>{userInfo?.FirstName}</span>
                    <img src={setting} alt="setting" />
                    <img src={logoutIcon} alt="logout" className='cursor-pointer' onClick={logout} />
                </div>
            </header>
            <div className='dashboard-layout-content'>
                <Sidebar />
                <div className='vertical-divider'></div>
                <Outlet />
               
            </div>
        </div>
    )
}

export default DashboardLayout
